/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import axios from 'axios';
import { useRecoilValue } from 'recoil';
import { useMemo, createContext } from 'react';
import authAtom from '../atoms/auth/auth.atom';
import { getSubdomain } from './Utils';
import appAtom from '../atoms/auth/app.atom';

const subDomain = getSubdomain();
const { href: host } = window.location;
export const AxiosContext = createContext(null);
export const isStageEnv = host.includes("staging");
export const isTestEnv = host.includes('localhost') || host.includes('surge');
const isDevEnv = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' || isTestEnv;
export const baseURL = isDevEnv ? `https://api.estateplusng.com/api/${subDomain}/v1/` : (isStageEnv ? `https://apistaging.estateplusng.com/api/${subDomain}/v1/` : `https://api.estateplusng.com/api/${subDomain}/v1/`);
// export const baseURL = isDevEnv
//   ? `http://84.247.136.197/api/${subDomain}/v1/`
//   : `http://84.247.136.197/api/${subDomain}/v1/`;
export type HeaderType = {
  'Content-Type': string;
  Authorization?: string;
  Accept: string;
  'x-company-id'?: string;
  'x-estate-id'?: string;
};

export default function AxiosContextProvider({ children }: any) {
  const { isLoggedIn, user, token } = useRecoilValue(authAtom);
  const { company_id, estate_id } = useRecoilValue(appAtom);
  const axiosInstance = useMemo(() => {
    const headers: HeaderType = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    if (isLoggedIn) {
      headers.Authorization = `Bearer ${token}`;
      headers['x-company-id'] = `${company_id === null ? '' : company_id?.value}`;
      headers['x-estate-id'] = `${estate_id === null ? '' : estate_id?.value}`;
    }
    return axios.create({ baseURL, headers });
  }, [isLoggedIn, user, company_id, estate_id]);

  return (
    <AxiosContext.Provider value={axiosInstance as unknown as null}>
      {children}
    </AxiosContext.Provider>
  );
}
